export default __webpack_public_path__ + "45fcec420cad577879295980f22b7649.webp";